import { cn } from '@/lib/utils';

export const SectionHeader = ({ index, eyebrow, title, description, dark = false, align = 'center', testid }) => (
  <div
    className={cn('max-w-2xl', align === 'center' ? 'mx-auto text-center' : 'text-left')}
    data-testid={testid}
  >
    <p
      className={cn(
        'flex items-center gap-3',
        align === 'center' ? 'justify-center' : 'justify-start'
      )}
    >
      {index && (
        <span className="font-mono text-xs font-medium tracking-widest text-gold-700">{index}</span>
      )}
      <span
        className={cn(
          'text-xs font-bold uppercase tracking-[0.2em]',
          dark ? 'text-gold-500' : 'text-gold-700'
        )}
      >
        {eyebrow}
      </span>
    </p>
    <h2
      className={cn(
        'mt-4 text-balance text-3xl font-extrabold tracking-tight sm:text-4xl',
        dark ? 'text-white' : 'text-navy-900'
      )}
    >
      {title}
    </h2>
    {description && (
      <p
        className={cn(
          'mt-4 text-base leading-relaxed sm:text-lg',
          dark ? 'text-slate-300' : 'text-slate-600'
        )}
      >
        {description}
      </p>
    )}
  </div>
);
